import {Component, computed, effect, inject, input, output, signal, untracked} from '@angular/core';
import {DateUtilsService} from '../../../services/date-utils.service';
import {AuthService} from '../../../services/auth-service.service';

@Component({
	selector: 'app-information-conflit-modal',
	templateUrl: './information-conflit-modal.component.html',
	styleUrl: './information-conflit-modal.component.scss'
})
export class InformationConflitModalComponent {

	visible = input.required<boolean>();
	dateConflit = input.required<Date>();

	dateConflitFormatee = computed(() => this.dateUtilsService.formaterDateEnFormatLettre(this.dateConflit(), this.authService.getLangueUtilisateurFrontend()));

	visibleChange = output<boolean>();

	visibleLocal = signal(false);

	private dateUtilsService = inject(DateUtilsService);
	private authService = inject(AuthService);

	constructor() {
		// À chaque modification de visible qui est renseigné par le parent (ex à l'ouverture de la modale) on notifie modifie le visible local
		effect(() => {
			const visible = this.visible();
			untracked(() => this.visibleLocal.set(visible));
		});
	}

	/**
	 * Effectue les actions de fermeture de modal
	 */
	fermerModal(): void {
		this.visibleChange.emit(false);
		this.visibleLocal.set(false);
	}
}
